import AppDispatcher from "../dispatcher/AppDispatcher";

import AppConstants from "../constants/AppConstants";

import CategoryStore from "../stores/CategoryStore";

import Api from "../utils/Api";
import budgetStore from "../stores/BudgetStore";
import BudgetActions from "./BudgetActions";

// CategoryActions
export default
{
	async initialize()
	{
		if (!CategoryStore.getIsInitialized()) {
			try
			{
				const categories = await Api.getCategories();
				AppDispatcher.handleAction({
					actionType: AppConstants.CATEGORY_RECEIVE_DATA,
					categories: categories
				});
			}
			catch (err)
			{
				// TODO: BA-152 call a fail action
				console.log(err);
			}
		}
	},

	async saveCategory(category)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.CATEGORY_SAVE_PENDING
		});

		try
		{
			category = await Api.saveCategory(category);

			AppDispatcher.handleAction({
				actionType: AppConstants.CATEGORY_SAVE_SUCCESS,
				category
			});
			return category;
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.CATEGORY_SAVE_FAILURE,
				message
			});
		}
	},

	async deleteCategory(categoryId, replacementId)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.CATEGORY_DELETE_PENDING,
			categoryId,
			replacementId
		});

		try
		{
			const category = await Api.deleteCategory(categoryId, replacementId);

			AppDispatcher.handleAction({
				actionType: AppConstants.CATEGORY_DELETE_SUCCESS,
				categoryId,
				replacementId
			});

			// TODO: should this go somewhere else?
			// Don't like the possibility of a circular reference
			// but also need to make sure that any time a delete is called it reloads
			if (replacementId && budgetStore.getIsInitialized())
			{
				// If this.state.budgetAllocations??
				await BudgetActions.initialize(true);
			}

			return category;
		}
		catch(message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.CATEGORY_DELETE_FAILURE,
				message
			});
		}
	}
};



// WEBPACK FOOTER //
// ./Components/actions/CategoryActions.jsx